import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import HotRecommendations from './components/HotRecommendations';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="website"
        pageTitle="蘑菇视频 - 香蕉视频糖心视频高清电影电视剧在线观看"
        pageDescription="蘑菇视频提供香蕉视频、糖心视频等中外影视资源点播，涵盖韩国电影、美国大片、最新电视剧、热播剧集、动漫番剧，高清免费在线观看，不缓冲流畅播放。"
      />
      <Navbar />

      <main>
        <HeroSection />
        <CategoryCards />
        <HotRecommendations />
        <LatestUpdates />
      </main>

      <Footer />
    </>
  );
}